import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { MessagesState } from "./state+/messages.state";

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([MessagesState])]
})
export class MessageModule {}
